export default function SimpleManualPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Simple Manual Page Works!
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          If you can see this page, React Router is handling manual routes correctly.
        </p>
        <p className="text-sm text-gray-500">
          URL: {window.location.pathname}
        </p>
        <a href="/" className="bg-blue-600 text-white px-4 py-2 rounded mt-4 inline-block">
          Go Home
        </a>
      </div>
    </div>
  );
}